import { ResetPage } from '#/views/reset'
import { getLayout, LayoutWithoutSideMenu } from '#/widgets/layouts'

ResetPage.getLayout = getLayout(LayoutWithoutSideMenu, { titlePage: 'Сброс пароля' })

export default ResetPage
